module.exports = __webpack_public_path__ + "img/events.c741625e.jpeg";